import { useTranslation } from 'react-i18next';
import { PencilSquareIcon } from '@heroicons/react/24/outline';

import { Button, SmartTableCellProps } from '@/components/ui/daisy';
import { ROUTES } from '@/utils/routes';
import { Link } from 'react-router-dom';
import { ActivityProgress } from '@/models/ActivityProgress';

export default function CorrectActionCell({
  item,
}: SmartTableCellProps<ActivityProgress>) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pendencies.activities',
  });

  const klassId = item.klass?.id || 0;

  return (
    <Link to={ROUTES.ACTIVITIES.ACTIVITY_CORRECTION.PROGRESS(klassId, item.id)}>
      <Button size="sm" color="warning" variant="soft">
        <PencilSquareIcon className="w-4" />
        {t('correct')}
      </Button>
    </Link>
  );
}
